module.exports = __webpack_public_path__ + "img/IOC.4e281a34.svg";